import axios from "@/index";
const createCode = {
  state: {
    createCodeList: [],
    createCodeData: []
  },
  getters: {},
  actions: {
    getCreateCodeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setCreateCodeList",
                (state, { createCodeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getCreateCodeInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setCreateCodeInfo",
                (state, { createCodeData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setCreateCodeList(state, action) {
      state.createCodeList = action.createCodeList;
    },
    setCreateCodeInfo(state, action) {
      state.createCodeData = action.createCodeData;
    }
  }
};
export default createCode;
